import React, { useEffect } from "react";
import 'styles/main/Overlay.sass'
import { useSelector, useDispatch } from 'react-redux';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export default function Overlay() {
  const dispatch = useDispatch();
  const popup = useSelector((state) => state.popup);

  useEffect(() => { 
    console.log('render Overlay')
  });

  function closePopup(){
    dispatch({ type: 'SET_POPUP', payload: undefined});
  }

  if (!popup) return null

  return (
    <div id="ovCont">
      <div className="fadeOv"></div>
      <div className="popUpContainer">
        <div className="tableCenter">
          <div className="cellCenter">
            <div class="popUpCont">
              <div id="headerPop">  <p id="titlePop">{popup.title}</p>
                <div class="cerrarBut" onClick={() => closePopup()}></div>
              </div>
              <div id="contentPop">
                <SimpleBar autoHide={false} style={{ height: "100%" }}>
                  <div style={{width: "100%", height: "100%"}} dangerouslySetInnerHTML={{__html: popup.content}}></div>
                </SimpleBar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}